const echo = window.Echo;

const subscriptions = {};

/**
 * Public subscribe/unsubscribe functions
 */

export function subscribe(channel, event, callbacks) {
    if (!Array.isArray(callbacks))
        callbacks = [callbacks];

    for (let callback of callbacks)
        subscribeEvent(channel, event, callback);
}

export function unsubscribe(channel, event, callbacks) {
    if (!Array.isArray(callbacks))
        callbacks = [callbacks];

    for (let callback of callbacks)
        unsubscribeEvent(channel, event, callback);
}

/**
 * Echo management
 */

function getChannel(channel) {
    if (!subscriptions[channel])
        subscriptions[channel] = {};

    return echo.private(channel);
}

function subscribeEvent(channel, event, callback) {
    let echoChannel = getChannel(channel);

    // If this is the first event being subscribed on this channel, create an array for the callbacks
    if (!subscriptions[channel][event]) {
        subscriptions[channel][event] = [];

        // Tell Echo to notify us when an event arrives
        echoChannel.listen(event, e => handleEvent(channel, event, e));
    }

    // Add the callback to the list of callbacks for this event
    subscriptions[channel][event].push(callback);
}

function unsubscribeEvent(channel, event, callback) {
    // If we're not subscribed to this channel or event, there's nothing for us to do
    if (!subscriptions[channel] || !subscriptions[channel][event])
        return;

    // Remove the callback for this event
    let index = subscriptions[channel][event].indexOf(callback);
    if (index > -1)
        subscriptions[channel][event].splice(index, 1);

    // If there are no other callbacks for this channel, unsubscribe from the channel
    if (subscriptions[channel][event].length === 0) {
        delete subscriptions[channel][event];

        if (Object.keys(subscriptions[channel]).length === 0)
            leaveChannel(channel);
    }
}

function leaveChannel(channel) {
    delete subscriptions[channel];
    echo.leave(channel);
}

function handleEvent(channel, event, e) {
    if (!subscriptions[channel] || !subscriptions[channel][event])
        return;

    for (let callback of subscriptions[channel][event])
        callback(e);
}
